import type { components } from '@pba/types-openapi-client';
import { parseISO } from 'date-fns';
import { type UploadedFile, createUploadedFile } from './uploaded-file';

export type AgeGroup =
  | '18_to_24'
  | '25_to_34'
  | '35_to_44'
  | '45_to_54'
  | '55_to_64'
  | '65_or_over'
  | 'under_18'
  | null;

export type Profession = {
  editable: boolean;
  id: string;
  name: string;
};

export type UserBase = {
  ageGroup: AgeGroup;
  createdAt: Date;
  email: string;
  firstName: string;
  fullName: string;
  id: string;
  lastName: string;
  middleName?: string;
  name: string;
  nodeUserId?: string;
};

export type UserList = {
  coverPhoto?: UploadedFile;
  profession: null | Profession;
  profilePhoto?: UploadedFile;
} & UserBase;

export const createUserBase = (data: components['schemas']['UserBase']): UserBase => ({
  ageGroup: data.age_group,
  createdAt: parseISO(data.created_at),
  email: data.email,
  firstName: data.first_name,
  fullName: data.full_name,
  id: data.id,
  lastName: data.last_name,
  middleName: data.middle_name,
  name: data.name,
  nodeUserId: data.node_id,
});

export const createUserList = (data: components['schemas']['UserList']): UserList => ({
  ...createUserBase(data),
  coverPhoto: data.cover_photo ? createUploadedFile(data.cover_photo) : undefined,
  profession: data.profession,
  profilePhoto: data.profile_photo ? createUploadedFile(data.profile_photo) : undefined,
});
